// extracted by mini-css-extract-plugin
module.exports = {"skillsSection":"skills_skillsSection__3sTTn","colorOverlay":"skills_colorOverlay__1JQ9H","headerText":"skills_headerText__1YuZq","cardsContainer":"skills_cardsContainer__3NERD"};